export default __webpack_public_path__ + "static/media/suhaib.76b7f674.jpg";